const NUMBER_IN_POOLS_HEADERS_TABLE = [
    {
        name: 'Number',
        value: 'number',
        disabled: true,
        minWidth: 90,
        insertContent: true,
        grow: true,
    },
    {
        name: 'Name',
        value: 'name',
        grow: true,
    },
    {
        name: 'Purchase status',
        value: 'provider_order_status',
        align: 'center',
        minWidth: 132,
    },
    {
        name: 'Type',
        value: 'type',
        minWidth: 80,
    },
    {
        name: 'Status',
        value: 'status',
        align: 'center',
        minWidth: 80,
    },
]

const NUMBER_IN_POOLS_HEADERS_TABLE_WITH_ACTIONS = [
    ...NUMBER_IN_POOLS_HEADERS_TABLE,
    {
        name: 'Actions',
        value: 'actions',
        minWidth: 80,
        align: 'center',
        disabled: true,
    },
]

export {
    NUMBER_IN_POOLS_HEADERS_TABLE, NUMBER_IN_POOLS_HEADERS_TABLE_WITH_ACTIONS,
}
